import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
import { getSubjectDlList } from "@/api/managementCenter/specialManage";
import { remote } from "@/api/admin/dict";
export default {
  name: "SUBJECTDL",
  components: {
    draggable: draggable
  },
  props: ["childModules"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      tableLoading: false,
      subjectData: {},
      subData: [],
      itemData: [],
      activeName: "",
      dataShow: true,
      iconStr: "el-icon-arrow-down"
    };
  },
  created: function created() {
    var subject = this.moduleList.find(function (item) {
      return item.cardType === "SUBJECT";
    });

    if (subject) {
      this.subjectData = JSON.parse(JSON.stringify(subject.cardModules[0]));
    } else {
      this.subjectData = this.childModules;
    }
  },
  computed: _objectSpread({}, mapGetters(["moduleList"])),
  mounted: function mounted() {
    this.getSelData();
  },
  methods: {
    //获取类型
    getSelData: function getSelData() {
      var _this = this;

      remote("navlink_list").then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.subData = data.data || [];
          _this.activeName = data.data[0].value || [];

          _this.handleClick();
        } else {
          _this.$message.warning(data.msg || "获取类型失败!");
        }
      }).catch(function (err) {
        _this.$message.error(err.msg || "获取类型异常!");
      });
    },
    tranClick: function tranClick(blo) {
      if (blo) {
        this.dataShow = true;
        this.iconStr = "el-icon-arrow-down";
      } else {
        this.dataShow = false;
        this.iconStr = "el-icon-arrow-up";
      }
    },
    handleClick: function handleClick() {
      var _this2 = this;

      this.itemData = [];
      this.tableLoading = true;
      var params = {
        type: this.activeName || "",
        size: 100
      };
      getSubjectDlList(params).then(function (res) {
        _this2.tableLoading = false;
        _this2.itemData = res.data.data.records;
      });
    },
    goServe: function goServe(item) {
      window.open(item.url, "_blank", "noreferrer=yes");
    },
    goManage: function goManage() {
      var routeData = this.$router.resolve({
        path: "/management/navlink"
      });
      window.open(routeData.href);
    }
  },
  watch: {},
  filters: {}
};